export const categories = [
  { slug: 'trigger-sounds', name: '触发音合集', icon: 'ri-sound-module-line', description: '精选各类ASMR触发音，从耳语到敲击，每一段声音都精心录制，带来极致的颅内高潮体验。' },
  { slug: 'sleep-aid', name: '助眠放松', icon: 'ri-moon-line', description: '专为改善睡眠质量设计的ASMR音频，温柔的声线配合舒缓节奏，伴您进入甜美梦乡。' },
  { slug: 'stress-relief', name: '减压冥想', icon: 'ri-mental-health-line', description: '结合冥想引导与ASMR技术，帮助释放日常压力，找回内心平静与专注力。' },
  { slug: 'roleplay', name: '角色扮演', icon: 'ri-user-voice-line', description: '沉浸式角色扮演场景，让您仿佛置身于真实的SPA、理发店或诊所环境中。' },
  { slug: 'mouth-sounds', name: '吃播口腔音', icon: 'ri-restaurant-line', description: '精选各类食物咀嚼音、唇音和口腔触发音，满足不同听众的听觉偏好。' },
  { slug: 'nature-sounds', name: '自然白噪音', icon: 'ri-leaf-line', description: '雨声、海浪、森林鸟鸣等大自然的声音，营造远离喧嚣的宁静氛围。' },
];

export const featuredArticles = [
  {
    slug: 'ultimate-trigger-guide',
    title: '2026年度最佳ASMR触发音合集推荐',
    category: 'trigger-sounds',
    excerpt: '从经典敲击到创新耳语，我们精选了今年最受欢迎的50个ASMR触发音作品，每一个都经过专业录制和精心后期处理。',
    imageSeq: 'featured-01',
    date: '2026-07-28',
    readTime: '8',
    featured: true,
  },
  {
    slug: 'deep-sleep-asmr',
    title: '睡不着？试试这10个专业助眠ASMR音频',
    category: 'sleep-aid',
    excerpt: '失眠困扰着越来越多的人。我们邀请了专业ASMR艺术家，为你打造了一套科学的助眠音频方案，从呼吸引导到环境音，全方位帮助你快速入睡。',
    imageSeq: 'featured-02',
    date: '2026-07-25',
    readTime: '6',
    featured: true,
  },
  {
    slug: 'meditation-beginners',
    title: 'ASMR冥想入门：从零开始的减压之旅',
    category: 'stress-relief',
    excerpt: '冥想不必复杂。用ASMR的方式开始你的冥想练习，让声音引导你进入深度放松状态，适合任何想要减轻压力、提升专注力的人。',
    imageSeq: 'featured-03',
    date: '2026-07-22',
    readTime: '10',
    featured: true,
  },
];

export const articles = [
  {
    slug: 'ultimate-trigger-guide',
    title: '2026年度最佳ASMR触发音合集推荐',
    category: 'trigger-sounds',
    excerpt: '从经典敲击到创新耳语，我们精选了今年最受欢迎的50个ASMR触发音作品，每一个都经过专业录制和精心后期处理。带你探索ASMR触发音的无限可能。',
    imageSeq: 'article-01',
    date: '2026-07-28',
    readTime: '8',
    content: `## 什么是ASMR触发音？

ASMR（Autonomous Sensory Meridian Response），中文译为"自发性知觉经络反应"，是一种通过特定听觉刺激引发的愉悦感受。触发音是ASMR中最核心的元素之一。

## 2026年最热门触发音类型

### 1. 敲击音
从木质桌面到玻璃瓶，不同材质的敲击带来截然不同的听觉体验。2026年最受欢迎的是多层次复合敲击音。

### 2. 耳语与轻声细语
温柔的人声永远是不可替代的ASMR经典。今年的趋势是双声道立体耳语，让声音在左右耳之间流动。

### 3. 纸张与翻书声
复古风格的纸张摩擦声意外走红，许多人表示这让他们回忆起童年阅读的美好时光。

### 4. 水流与液体声
从倒水到搅拌，液体声音带来的满足感在2026年达到了新的高度。

### 5. 刷具与摩擦声
化妆刷、画笔在麦克风表面的轻柔滑动，创造出令人难以抗拒的酥麻感。

## 如何选择适合自己的触发音？

每个人的ASMR敏感度不同，建议从多种类型开始尝试，找到最能引发你"颅内高潮"感受的声音类型。asmr1平台提供了丰富的分类筛选功能，帮助你快速找到心仪的内容。`,
  },
  {
    slug: 'deep-sleep-asmr',
    title: '睡不着？试试这10个专业助眠ASMR音频',
    category: 'sleep-aid',
    excerpt: '失眠困扰着越来越多的人。我们邀请了专业ASMR艺术家，为你打造了一套科学的助眠音频方案。',
    imageSeq: 'article-02',
    date: '2026-07-25',
    readTime: '6',
    content: `## 为什么ASMR能帮助入睡？

科学研究表明，ASMR音频能够降低心率、减少皮质醇（压力激素）水平，帮助大脑从活跃的β波状态过渡到放松的α波，最终进入睡眠的θ波状态。

## 10个专业助眠ASMR推荐

### 1. 雨声白噪音
均匀的雨声是公认的最佳助眠音之一，它能有效掩盖环境噪音，创造稳定的听觉背景。

### 2. 海浪拍岸声
有节奏的海浪声模仿了我们在母体内听到的声音，具有天然的安抚效果。

### 3. 呼吸引导
跟随专业的呼吸节奏指导，从4-7-8呼吸法开始，逐步放慢呼吸频率。

### 4. 渐进式肌肉放松引导
从头到脚逐步放松每一块肌肉，配合温柔的ASMR人声，身体自然进入休息状态。

### 5. 篝火噼啪声
温暖的篝火声营造出安全舒适的氛围，让人仿佛置身于温馨的木屋中。

### 6. 森林鸟鸣
清晨森林的自然声音帮助大脑释放褪黑素，调节生物钟。

### 7. 心跳声模拟
规律的心跳声是最原始的安抚声音，特别适合感到焦虑的时刻。

### 8. 梳头声
模拟梳头的轻柔声音带来被照顾的安心感，是非常独特的助眠体验。

### 9. 翻书页声
有节奏的翻页声和纸张摩擦声让人想起睡前阅读的美好习惯。

### 10. 太空舱环境音
科幻风格的持续低频嗡嗡声创造了一个与世隔绝的安静空间。

## 使用建议

建议在睡前30分钟开始收听，配合舒适的耳机和昏暗的灯光环境。asmr1平台的所有助眠音频都经过专业混音，确保没有任何突兀的声音会打断你的入睡过程。`,
  },
  {
    slug: 'meditation-beginners',
    title: 'ASMR冥想入门：从零开始的减压之旅',
    category: 'stress-relief',
    excerpt: '冥想不必复杂。用ASMR的方式开始你的冥想练习，让声音引导你进入深度放松状态。',
    imageSeq: 'article-03',
    date: '2026-07-22',
    readTime: '10',
    content: `## ASMR与冥想的完美结合

传统冥想需要一定的专注力基础，而ASMR冥想则通过声音刺激让大脑自然进入冥想状态，大大降低了入门门槛。

## 三步开始ASMR冥想

### 第一步：环境准备
找一个安静的空间，戴上高品质耳机，调整到舒适的音量。建议选择asmr1的"减压冥想"分类。

### 第二步：呼吸同步
跟随音频中的呼吸引导，吸气4秒、屏息4秒、呼气6秒。重复5次后你会感到明显的放松。

### 第三步：声音沉浸
将注意力完全放在声音上，让每一个触发音带走你的一个烦恼。不要刻意"想"什么，只需"感受"声音。

## 不同场景的ASMR冥想推荐

- **早晨唤醒**：选择自然白噪音和轻柔鸟鸣
- **午间充电**：15分钟的快速减压触发音
- **工作间隙**：5分钟的手指敲击音放松
- **睡前放松**：30分钟的深度冥想引导

## 常见问题

**Q: 我听ASMR没有感觉怎么办？**
A: 每个人对不同触发音的敏感度不同，建议多尝试不同类型，asmr1提供了6大分类供你探索。

**Q: 需要每天冥想吗？**
A: 建议从每周2-3次开始，每次10-15分钟，逐步建立习惯。`,
  },
  {
    slug: 'spa-roleplay-experience',
    title: '沉浸式SPA角色扮演：在家享受专业级放松体验',
    category: 'roleplay',
    excerpt: '不用出门，戴上耳机就能体验顶级SPA服务。我们的SPA角色扮演ASMR让你感受从头到脚的放松。',
    imageSeq: 'article-04',
    date: '2026-07-20',
    readTime: '7',
    content: `## 什么是ASMR角色扮演？

ASMR角色扮演通过精心设计的场景和声音，让你仿佛置身于真实的SPA、理发店或诊所中。这种沉浸式体验能带来极强的放松效果。

## 热门SPA角色扮演场景

### 1. 面部护理
从洁面到面膜，每一个步骤的声音细节都被完美还原。你会听到化妆水轻拍、面霜涂抹的细腻声音。

### 2. 头部按摩
模拟专业按摩师的手指在头皮上移动的声音，配合温和的问候语，如同亲身享受头部SPA。

### 3. 肩颈放松
听到按摩油的倒出声和手掌在皮肤上的揉捏声，紧张的肩颈肌肉仿佛真的被释放了。

### 4. 耳部清洁
这是ASMR中最经典的角色扮演之一，棉签在耳边轻轻移动的声音带来极致的酥麻感。

## 如何获得最佳体验

闭上眼睛，放松身体，想象自己正躺在专业的SPA床上。asmr1推荐使用高保真耳机以获得最真实的双声道立体声效果。`,
  },
  {
    slug: 'crunchy-mouth-sounds',
    title: '脆爽吃播ASMR：让人欲罢不能的口腔音合集',
    category: 'mouth-sounds',
    excerpt: '从酥脆炸鸡到多汁水果，精选最具满足感的吃播口腔音，每一种都让人听了就停不下来。',
    imageSeq: 'article-05',
    date: '2026-07-18',
    readTime: '5',
    content: `## 吃播ASMR的魅力

吃播ASMR（Mukbang ASMR）起源于韩国，通过高灵敏度麦克风捕捉食物咀嚼的每一个细节声音，为听众带来极大的听觉满足感。

## 最受欢迎的食物类型

### 酥脆系
炸鸡、薯片、饼干——酥脆的声音是吃播ASMR中最经典的类型，高频的碎裂声能触发强烈的ASMR反应。

### 多汁系
西瓜、橙子、葡萄——水果被咬开时汁水迸发的声音带来极致的满足感。

### 软糯系
年糕、麻薯、棉花糖——柔软而有嚼劲的食物产生的低沉咀嚼音别有一番风味。

### 冰爽系
冰块、冰淇淋、冰沙——低温食物特有的清脆碎裂声在夏天格外受欢迎。

## 收听建议

asmr1推荐在用餐时不要收听（可能会影响正常饮食节奏），适合在放松时作为背景音享受。`,
  },
  {
    slug: 'nature-white-noise',
    title: '大自然的声音：6种治愈系白噪音场景推荐',
    category: 'nature-sounds',
    excerpt: '城市生活充满噪音，让我们回归大自然的声音。精选6种最治愈的自然白噪音，帮你找回内心的宁静。',
    imageSeq: 'article-06',
    date: '2026-07-15',
    readTime: '6',
    content: `## 白噪音的科学

白噪音是一种在所有频率上具有相同功率的随机信号。在自然界中，许多声音都具有类似白噪音的特性，它们能够掩盖突然出现的干扰声音，创造稳定的听觉环境。

## 六大自然白噪音场景

### 1. 雨打芭蕉
热带雨林中的大雨声，密集而有节奏，是最经典的白噪音之一。适合需要高度专注时收听。

### 2. 海浪轻拍
温和的海浪声介于白噪音和粉红噪音之间，低频更丰富，特别适合助眠。

### 3. 山涧溪流
清澈的溪水在石头间流淌的声音，清脆而不刺耳，适合冥想和放松。

### 4. 竹林风声
风吹过竹林时竹叶摩擦的沙沙声，这是最具东方意境的自然白噪音。

### 5. 篝火燃烧
木柴燃烧时的噼啪声和轻微的爆裂声，温暖的质感让人感到安全和舒适。

### 6. 夏日蝉鸣
蝉鸣声虽然是昆虫发出的，但它均匀的节奏感使它成为绝佳的自然白噪音来源。

## 使用场景推荐

- **工作学习**：雨声、溪流声
- **睡眠**：海浪声、篝火声
- **冥想**：竹林风声
- **午休**：夏日蝉鸣`,
  },
  {
    slug: 'tapping-heaven',
    title: '指尖魔法：50种敲击触发音让你颅内高潮',
    category: 'trigger-sounds',
    excerpt: '敲击音是ASMR最经典的触发类型之一。我们整理了50种不同材质、不同节奏的敲击音，满足最挑剔的耳朵。',
    imageSeq: 'article-07',
    date: '2026-07-12',
    readTime: '9',
    content: `## 敲击音的ASMR原理

敲击音通过不规则的节奏和不同材质的音色变化，持续刺激听觉神经，引发ASMR反应。这种不可预测性正是敲击音的魅力所在。

## 50种敲击音分类

### 木质敲击（10种）
木桌、木盒、竹筒、木勺、铅笔、积木、木板、树皮、藤编、木琴

### 金属敲击（10种）
硬币、钥匙、勺子、金属盒、铝罐、铃铛、音叉、铁片、铜碗、金属笔

### 玻璃与陶瓷（10种）
玻璃杯、陶瓷碗、水晶球、玻璃瓶、瓷砖、瓷器、酒杯、花瓶、玻璃珠、陶瓷杯

### 塑料与合成材料（10种）
塑料瓶盖、键盘、鼠标、手机壳、信用卡、梳子、CD盒、遥控器、亚克力板、橡胶

### 特殊材质（10种）
贝壳、石头、蛋壳、坚果壳、冰块、蜡烛、皮革、海绵、纸板、羽毛

## 收听技巧

asmr1建议使用监听级耳机以获得最丰富的细节。尝试闭眼专注聆听，让声音带你进入完全放松的状态。`,
  },
  {
    slug: 'haircut-roleplay',
    title: '理发店ASMR角色扮演：剪刀与梳子的交响曲',
    category: 'roleplay',
    excerpt: '理发店是ASMR角色扮演中最受欢迎的场景之一。剪刀的咔嚓声、电推剪的嗡嗡声，带你重温理发店的美好体验。',
    imageSeq: 'article-08',
    date: '2026-07-10',
    readTime: '7',
    content: `## 理发店ASMR的独特魅力

理发店ASMR结合了多种触发音元素：人声交流、工具声音、环境音效。这种复合型的听觉体验能触发更强烈的ASMR反应。

## 经典理发店场景流程

### 1. 迎接与咨询
温柔的问候声，轻声询问你想要的发型。这种被关注的感觉本身就是一种放松。

### 2. 洗发
水流声、洗发水挤压声、头部按摩声——这是理发店ASMR中最放松的环节。

### 3. 剪发
剪刀有节奏的咔嚓声是理发店ASMR的灵魂。专业理发师的剪刀技法创造出独特的听觉韵律。

### 4. 电推剪
电推剪的低频嗡嗡声是一种非常有效的触发音，很多人表示这是他们最喜欢的部分。

### 5. 吹风造型
吹风机的风声配合梳子梳理头发的沙沙声，为整个体验画上完美句号。

## 最佳收听姿势

躺在舒适的椅子上，闭上眼睛，想象自己正坐在专业理发店的椅子上。asmr1建议使用降噪耳机以获得最佳沉浸感。`,
  },
  {
    slug: 'office-stress-relief',
    title: '办公室5分钟快速减压：上班族必备ASMR指南',
    category: 'stress-relief',
    excerpt: '工作压力大？试试这套专为办公室场景设计的5分钟ASMR快速减压方案，不需要特殊设备，随时随地为心情充电。',
    imageSeq: 'article-09',
    date: '2026-07-08',
    readTime: '4',
    content: `## 办公室ASMR的优势

不需要专门的冥想室或瑜伽垫，只需要一副耳机和5分钟时间。办公室ASMR是在高压工作环境中快速恢复专注力的最佳工具。

## 5分钟减压方案

### 第1分钟：深呼吸同步
跟随音频中的呼吸节奏，缓慢吸气、缓慢呼气。这一分钟帮助你从工作模式切换到放松模式。

### 第2-3分钟：键盘敲击ASMR
有节奏的机械键盘敲击声能带来意想不到的满足感，同时不会引起同事的注意。

### 第4分钟：翻页与纸张音
模拟翻文件和纸张的声音，轻柔而有条理，帮助大脑重新整理思绪。

### 第5分钟：钢笔书写音
圆珠笔在纸上的沙沙声是经典的专注力触发音，让你以平静的心态回到工作中。

## 使用时机

- 上午10:30 第一次减压（工作2小时后）
- 下午2:00 午后提神
- 下午4:00 下班前放松

asmr1的"快速减压"分类专门为时间有限的上班族打造，每段音频不超过10分钟。`,
  },
];

export const testimonials = [
  { name: '小雨', role: '大学生', content: 'asmr1是我每天睡前必用的平台，助眠音频真的太有效了！以前要辗转反侧1小时才能睡着，现在15分钟就进入梦乡。', rating: 5 },
  { name: '明哲', role: '程序员', content: '工作压力大的时候，打开asmr1听一段敲击音，瞬间感觉大脑被重置了一样，专注力明显提升。', rating: 5 },
  { name: '诗涵', role: '瑜伽教练', content: '我把asmr1的自然白噪音用在瑜伽课上，学员们反馈非常好，说更容易进入冥想状态了。', rating: 5 },
  { name: '浩然', role: '自由职业者', content: '之前对ASMR持怀疑态度，试了asmr1的角色扮演系列后彻底入坑了。SPA场景太真实了，在家就能享受！', rating: 5 },
  { name: '芷若', role: '初中老师', content: '批改作业到深夜时喜欢听asmr1的雨声白噪音，不仅帮助集中注意力，还能缓解一天的疲惫。', rating: 4 },
  { name: '俊杰', role: '设计师', content: '创意枯竭的时候就打开asmr1的触发音合集，声音刺激总能带来新的灵感火花。', rating: 5 },
];

export const faqs = [
  { question: 'asmr1是什么？', answer: 'asmr1是一个专注于沉浸式ASMR音频体验的平台，我们精心挑选和制作各类ASMR触发音、助眠音频、减压冥想等内容，为用户提供高品质的听觉享受和放松体验。' },
  { question: 'ASMR对所有人都有效吗？', answer: '每个人对ASMR的敏感度和触发类型偏好不同。有的人对敲击音特别敏感，有的人更喜欢人声耳语。建议多尝试asmr1的不同分类内容，找到最适合自己的类型。大约70%的人在第一次体验时就能感受到明显的放松效果。' },
  { question: '听ASMR需要什么设备？', answer: '为了获得最佳的沉浸式体验，我们推荐使用高品质的入耳式或头戴式耳机。普通手机自带扬声器也能收听，但立体声和细节会有所损失。asmr1的所有音频都支持双声道立体声播放。' },
  { question: 'ASMR音频可以帮助治疗失眠吗？', answer: '虽然ASMR不是医疗手段，但大量用户反馈表明，定期收听ASMR助眠音频可以显著改善入睡困难的问题。科学原理是通过降低心率、减少压力激素来帮助身体自然进入睡眠状态。如果您有严重的睡眠障碍，建议同时咨询专业医生。' },
  { question: 'asmr1的内容会定期更新吗？', answer: '是的！我们的内容团队每周都会更新新的ASMR音频内容，涵盖触发音合集、助眠放松、减压冥想等多个分类。订阅我们的Newsletter可以第一时间收到更新通知。' },
  { question: '如何判断哪种ASMR类型适合我？', answer: '我们建议从"触发音合集"和"自然白噪音"两个分类开始尝试，这两个分类覆盖面广，触发效果普遍较好。如果目标是助眠，可以直接选择"助眠放松"分类。asmr1的每个分类都有详细的介绍和试听推荐。' },
];